/**
 * 지원하는 언어 타입 정의
 */
export type LanguageCode = "ko" | "en";

/**
 * 언어 정보 인터페이스
 */
export interface LanguageInfo {
  code: LanguageCode;
  name: string;
  nativeName: string;
  flag: string;
}

/**
 * 지원하는 언어 목록
 * 새로운 언어 추가 시 여기에 추가하면 됩니다.
 */
export const SUPPORTED_LANGUAGES: Record<LanguageCode, LanguageInfo> = {
  ko: {
    code: "ko",
    name: "Korean",
    nativeName: "한국어",
    flag: "🇰🇷",
  },
  en: {
    code: "en",
    name: "English",
    nativeName: "English",
    flag: "🇺🇸",
  },
};

/**
 * 기본 언어 설정
 */
export const DEFAULT_LANGUAGE: LanguageCode = "ko";

/**
 * 언어 코드 배열 (순서대로)
 */
export const LANGUAGE_ORDER: LanguageCode[] = ["ko", "en"];
